import {
  Component,
  OnInit,
  Input,
  OnDestroy,
} from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';

import { v4 as uuidv4 } from 'uuid';

import { Tables } from 'src/app/shared/entities/tables';

import { ViewService } from 'src/app/admin/core/services/viewservice';

import { DynamicDocumentInfoService } from 'src/app/shared/services/dynamic-document-info.service';
import { DynamicDocumentService } from 'src/app/shared/services/dynamic-document.service';
import { NotificationService } from 'src/app/services/notification.service';

import { DynamicDocumentInfo } from 'src/app/shared/entities/dynamic-document';

@Component({
  selector: 'app-import-fichier',
  templateUrl: './import-fichier.component.html',
  styleUrls: ['./import-fichier.component.css'],
})
export class ImportFichierComponent implements OnInit, OnDestroy {

  @Input() tab: Tables = new Tables();

  file: File | null = null;

  types: any[] = [
    { label: 'CSV', value: 'csv' },
    { label: 'XLS', value: 'xls' },
    { label: 'XLSX', value: 'xlsx' }
  ];
  selectedType: string = 'csv';

  records: any[] | null = null;
  nbIgnored: number = 0;
  nbSuccess: number = 0;
  nbWarnings: number = 0;
  nbErrors: number = 0;
  nbTotal: number = 0;

  views: any[] = [];
  selectedView: string = '';

  inProgress: boolean = false;

  progress: any = null;

  fileId: string;

  refreshListTable: boolean = false;

  private _dynamicDocumentInfo: DynamicDocumentInfo | null = null;

  constructor(private readonly _httpClient: HttpClient,
    // private readonly _dialog: MatDialog,
    private readonly _viewService: ViewService,
    private readonly _dynamicDocumentInfoService: DynamicDocumentInfoService,
    private readonly _dynamicDocumentService: DynamicDocumentService,
    private readonly _notificationService: NotificationService,
    private dialog: MatDialogRef<any>) { }

  public async ngOnInit(): Promise<void> {
    this._dynamicDocumentInfo = await this.retrieveDynamicDocumentInfo(this.tab.entite);
    this._viewService.getViews(this.tab.title, this.tab.entite).map(view => this.views.push({ label: view.nom, value: view.id }));
  }

  public ngOnDestroy(): void {
    this._notificationService.unsubscribeImportFileNotification();
  }

  public onExportTrameFile(): void {
    if (this._dynamicDocumentInfo !== null) {
      const exportFileRequest: any = {
        ids: null,
        filters: null,
        locales: this.tab.locales,
        isUseLabel: false
      };

      if (this.selectedView !== undefined && this.selectedView !== null && this.selectedView !== '') { // On view
        this._dynamicDocumentService.exportFileOnView(this.tab.entite, this.selectedType, this.selectedView, exportFileRequest).subscribe((data: Blob) => {
          const blob = new Blob([data], this.selectedType === 'csv' ? { type: 'application/csv' } : { type: 'application/vnd.ms-excel' });

          const objectUrl = window.URL.createObjectURL(blob);

          const link = document.createElement('a');
          link.href = objectUrl;
          link.download = `export.${this.selectedType}`;
          link.click();

          URL.revokeObjectURL(objectUrl);
        });
      } else {
        this._dynamicDocumentService.exportFile(this.tab.entite, this.selectedType, exportFileRequest).subscribe((data: Blob) => {
          const blob = new Blob([data], this.selectedType === 'csv' ? { type: 'application/csv' } : { type: 'application/vnd.ms-excel' });

          const objectUrl = window.URL.createObjectURL(blob);

          const link = document.createElement('a');
          link.href = objectUrl;
          link.download = `export.${this.selectedType}`;
          link.click();

          URL.revokeObjectURL(objectUrl);
        });
      }
    } else {
      const url: string = (this.selectedView !== undefined && this.selectedView !== null && this.selectedView !== '')
        ? `/entite/export/trame/view/${this.selectedView}/${this.selectedType}`
        : `/entite/export/trame/${this.tab.entite}/${this.selectedType}`

      this._httpClient.post<Blob>(url, this.tab.locales, { responseType: 'blob' as 'json' }).subscribe((data: Blob) => {
        const blob = new Blob([data], this.selectedType === 'csv' ? { type: 'application/csv' } : { type: 'application/vnd.ms-excel' });

        const objectUrl = window.URL.createObjectURL(blob);

        const link = document.createElement('a');
        link.href = objectUrl;
        link.download = `export.${this.selectedType}`;
        link.click();

        URL.revokeObjectURL(objectUrl);
      });
    }
  }

  public onImportFile($event: any): void {
    this.file = $event.target.files[0];
  }

  public onDownloadReport(): void {
    if (this.records !== null) {
      let text = '';

      text += `Nombre de lignes traitées = ${this.nbTotal}\n`;
      text += `Nombre de lignes ignorées = ${this.nbIgnored}\n`;
      text += `Nombre de lignes validées = ${this.nbSuccess}\n`;
      text += `Nombre de lignes avec alerte = ${this.nbWarnings}\n`;
      text += `Nombre de lignes en erreur = ${this.nbErrors}\n\n`;

      for (const record of this.records) {
        if (record.type === 'IGNORED') {
          text += `${record.row} : IGNORE\n`
        } else if (record.type === 'WARNING') {
          text += `ALERTE [LIGNE ${record.row} - COLONNE ${record.column}] ${record.message}\n`;
        } else if (record.type === 'ERROR' && record.column !== undefined && record.column !== null && record.column !== '') {
          text += `ERREUR [LIGNE ${record.row} - COLONNE ${record.column}] ${record.message}\n`;
        } else if (record.type === 'ERROR' && (record.column === undefined || record.column === null || record.column === '')) {
          text += `ERREUR [LIGNE ${record.row}] ${record.message}\n`;
        }
      }

      const link = document.createElement('a');
      link.href = 'data:text/plain;charset=utf-8,' + encodeURIComponent(text);
      link.download = 'rapport.txt';
      link.click();
    }
  }

  public onCancel(): void {
    if (this.inProgress) {
      this._dynamicDocumentService.cancelImportFile(this.tab.entite).subscribe(() => {
        if (this.records !== null) {
          this._notificationService.unsubscribeImportFileNotification();
          this.dialog.close(this.refreshListTable);
        }
      });
    } else {
      this._notificationService.unsubscribeImportFileNotification();
      this.dialog.close(this.refreshListTable);
    }
  }

  public onClose(): void {
    this._notificationService.unsubscribeImportFileNotification();
    this.dialog.close(this.refreshListTable);
  }

  public onSubmit(): void {
    this.refreshListTable = true;
    if (this.file !== null) {
      if (this._dynamicDocumentInfo !== null) {
        this.inProgress = true;
        this.fileId = uuidv4();

        this._notificationService.subscribeImportFileNotification(this.fileId, (notification: any) => {
          if (notification.type === 'IMPORT_FILE_PROGRESS') {
            this.progress = notification;
          } else if (notification.type === 'IMPORT_FILE_REPORT') {
            const report = notification.report;
            if (report !== undefined || report !== null) {
              const records: any[] = report.records;
              for (let i = 0; i < records.length; i++) {
                const record: any = records[i];
                if (record.type === 'IGNORED') {
                  this.nbIgnored++;
                } else if (record.type === 'SUCCESS') {
                  this.nbSuccess++;
                } else if (record.type === 'WARNING') {
                  this.nbWarnings++;
                } else if (record.type === 'ERROR') {
                  this.nbErrors++;
                }
                this.nbTotal++;
              }
              this.records = records;
            } else {
              this.records = null;
            }
          }
        });

        this._dynamicDocumentService.importFile(this.tab.entite, this.file, this.fileId).subscribe({
          next: () => {
          }, error: () => { }
        });
      } else {
        const formData: FormData = new FormData();
        formData.append('file', this.file, this.file.name);

        const options: any = {};
        options.headers = new HttpHeaders();
        options.headers.set('Content-Type', 'multipart/form-data');
        options.headers.set('Accept', 'application/json');
        options.headers.set('Access-Control-Allow-Origin', '*');
        options.reportProgress = true;

        this.inProgress = true;

        this._httpClient.post(`/entite/import/${this.tab.entite}`, formData, options).subscribe((report: any) => {
          if (report !== undefined || report !== null) {
            const records: any[] = report.records;
            for (let i = 0; i < records.length; i++) {
              const record: any = records[i];
              if (record.type === 'IGNORED') {
                this.nbIgnored++;
              } else if (record.type === 'SUCCESS') {
                this.nbSuccess++;
              } else if (record.type === 'WARNING') {
                this.nbWarnings++;
              } else if (record.type === 'ERROR') {
                this.nbErrors++;
              }
              this.nbTotal++;
            }
            this.records = records;
          } else {
            this.records = null;
          }
        }, (error: any) => console.log(error));
      }
    }
  }

  private retrieveDynamicDocumentInfo(documentName: string): Promise<DynamicDocumentInfo | null> {
    return new Promise<DynamicDocumentInfo | null>((resolve: (dynamicDocumentInfo: DynamicDocumentInfo | null) => void) => {
      this._dynamicDocumentInfoService.findByDocumentName(documentName).subscribe({
        next: (dynamicDocumentInfo: DynamicDocumentInfo) => { // Is dynamic document
          resolve(dynamicDocumentInfo);
        },
        error: () => { // Is static document
          resolve(null);
        },
      });
    });
  }
}
